// import React, { useState, useEffect } from "react";
// import { Card, Divider, Spin } from "antd";
// import settingService from "../../services/settingService";
// import "./OrderSummary.css";

// const OrderSummary = ({ items, total }) => {
//   const [deliveryFee, setDeliveryFee] = useState(0);
//   const [loading, setLoading] = useState(true);
//   const [nextFreeShipping, setNextFreeShipping] = useState(null);

//   useEffect(() => {
//     fetchDeliveryFee();
//   }, [total]);

//   const fetchDeliveryFee = async () => {
//     try {
//       setLoading(true);
//       const response = await settingService.getSettings();

//       if (response?.success) {
//         const deliveryFees = response.data.deliveryFees || [];

//         // Find matching delivery fee based on total
//         const matchingFee = deliveryFees.find(
//           (fee) =>
//             fee.isActive && total >= fee.minAmount && total <= fee.maxAmount
//         );

//         setDeliveryFee(matchingFee ? matchingFee.fee : 0);

//         // Find next free shipping threshold
//         if (matchingFee && matchingFee.fee > 0) {
//           const nextFreeTier = deliveryFees.find(
//             (fee) => fee.isActive && fee.fee === 0 && fee.minAmount > total
//           );

//           if (nextFreeTier) {
//             setNextFreeShipping(nextFreeTier.minAmount - total);
//           }
//         }
//       }
//     } catch (error) {
//       console.error("Error fetching delivery fee:", error);
//       setDeliveryFee(0);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const finalTotal = total + deliveryFee;

//   return (
//     <Card className="order-summary-card">
//       <h3>Order Summary</h3>

//       <div className="summary-items">
//         {items?.map((item, index) => (
//           <div key={index} className="summary-item">
//             <div className="item-details">
//               <img src={item.images?.[0]?.url || item.image} alt={item.name} />
//               <div>
//                 <p className="item-name">{item.name}</p>
//                 <p className="item-size">Size: {item.selectedSize}</p>
//                 <p className="item-qty">Qty: {item.quantity}</p>
//               </div>
//             </div>
//             <p className="item-price">
//               ₹{(item.price * item.quantity).toLocaleString()}
//             </p>
//           </div>
//         ))}
//       </div>

//       <Divider />

//       <div className="summary-calculations">
//         <div className="summary-row">
//           <span>Subtotal</span>
//           <span>₹{total.toLocaleString()}</span>
//         </div>
//         <div className="summary-row">
//           <span>Delivery Fee</span>
//           {loading ? (
//             <Spin size="small" />
//           ) : (
//             <span className={deliveryFee === 0 ? "free" : ""}>
//               {deliveryFee === 0 ? "FREE" : `₹${deliveryFee}`}
//             </span>
//           )}
//         </div>
//         <Divider />
//         <div className="summary-row total">
//           <span>Total</span>
//           <span>₹{finalTotal.toLocaleString()}</span>
//         </div>
//       </div>

//       {nextFreeShipping && nextFreeShipping > 0 && (
//         <p className="delivery-note">
//           Add ₹{nextFreeShipping.toLocaleString()} more for FREE delivery
//         </p>
//       )}
//     </Card>
//   );
// };

// export default OrderSummary;

import React from "react";
import { Card, Divider } from "antd";
import "./OrderSummary.css";

const OrderSummary = ({
  items,
  total,
  deliveryFee = 0,
  discount = 0,
  finalTotal,
}) => {
  const calculatedFinalTotal = finalTotal || total + deliveryFee - discount;

  // Calculate total savings from offer prices
  const totalOfferSavings = items?.reduce((savings, item) => {
    if (item.offerPrice && item.offerPrice < item.price) {
      return savings + (item.price - item.offerPrice) * item.quantity;
    }
    return savings;
  }, 0) || 0;

  return (
    <Card className="order-summary-card">
      <h3>Order Summary</h3>

      <div className="summary-items">
        {items?.map((item, index) => {
          const hasOffer = item.offerPrice && item.offerPrice < item.price;
          const displayPrice = hasOffer ? item.offerPrice : item.price;

          return (
            <div key={index} className="summary-item">
              <div className="item-details">
                <img src={item.images?.[0]?.url || item.image} alt={item.name} />
                <div>
                  <p className="item-name">{item.name}</p>
                  <p className="item-size">Size: {item.selectedSize}</p>
                  <p className="item-qty">Qty: {item.quantity}</p>
                </div>
              </div>
              <div className="item-price">
                {hasOffer ? (
                  <>
                    <p className="offer-price">
                      ₹{(displayPrice * item.quantity).toLocaleString()}
                    </p>
                    <p className="original-price">
                      ₹{(item.price * item.quantity).toLocaleString()}
                    </p>
                  </>
                ) : (
                  <p>₹{(displayPrice * item.quantity).toLocaleString()}</p>
                )}
              </div>
            </div>
          );
        })}
      </div>

      <Divider />

      <div className="summary-calculations">
        <div className="summary-row">
          <span>Subtotal</span>
          <span>₹{total.toLocaleString()}</span>
        </div>
        {totalOfferSavings > 0 && (
          <div className="summary-row savings">
            <span>Product Savings</span>
            <span className="savings-amount">
              -₹{totalOfferSavings.toLocaleString()}
            </span>
          </div>
        )}
        <div className="summary-row">
          <span>Delivery Fee</span>
          <span className={deliveryFee === 0 ? "free" : ""}>
            {deliveryFee === 0 ? "FREE" : `₹${deliveryFee}`}
          </span>
        </div>
        {discount > 0 && (
          <div className="summary-row discount">
            <span>Coupon Discount</span>
            <span className="discount-amount">-₹{discount.toFixed(2)}</span>
          </div>
        )}
        <Divider />
        <div className="summary-row total">
          <span>Total</span>
          <span>₹{calculatedFinalTotal.toLocaleString()}</span>
        </div>
        {(totalOfferSavings > 0 || discount > 0) && (
          <div className="total-savings-banner">
            <span>
              🎉 You saved ₹
              {(totalOfferSavings + discount).toLocaleString()} on this order!
            </span>
          </div>
        )}
      </div>
    </Card>
  );
};

export default OrderSummary;
